/** What a comment is left on (a PO, an action item, an invoice), as the tags it carries. */
export type CommentContextMention = {
  entity_type: string
  entity_uuid: string
  display_text: string
}

export type NewComment = {
  content: string
  mentions: Array<{ entity_type: string; entity_uuid: string; display_text: string }>
}

/** A new comment with tags for what it was left on (a PO, an action item, an invoice) in front of its text. */
export function withContextTags(
  { content, mentions: typed }: NewComment,
  context: readonly CommentContextMention[],
): NewComment {
  const contextMarkup = context
    .map((mention) => `@[${mention.display_text}](${mention.entity_type}:${mention.entity_uuid})`)
    .join(' ')
  const mentions = [
    ...context,
    ...typed.filter(
      (mention) =>
        !context.some((own) => own.entity_type === mention.entity_type && own.entity_uuid === mention.entity_uuid),
    ),
  ]
  return { content: contextMarkup ? `${contextMarkup} ${content}` : content, mentions }
}
